module.exports = __webpack_public_path__ + "static/media/FaithfulFriends.74c1cc78.jpg";